import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const rocksdbRWKVSchema: Schema = {
  title: 'KV',
  level: 3,
  columns: commonColumns
}
